function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSignal2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.828125 4.089844 L 15.585938 4.089844 L 15.585938 14.910156 L 13.828125 14.910156 Z M 4.105469 8.003906 C 3.949219 8.160156 3.691406 8.160156 3.53125 8.003906 C 3.375 7.84375 3.375 7.585938 3.53125 7.429688 L 4.855469 6.105469 L 3.53125 4.78125 C 3.375 4.625 3.375 4.367188 3.53125 4.207031 C 3.691406 4.050781 3.949219 4.050781 4.105469 4.207031 L 5.429688 5.53125 L 6.753906 4.207031 C 6.910156 4.050781 7.167969 4.050781 7.328125 4.207031 C 7.484375 4.367188 7.484375 4.625 7.328125 4.78125 L 6.003906 6.105469 L 7.328125 7.429688 C 7.484375 7.585938 7.484375 7.84375 7.328125 8.003906 C 7.167969 8.160156 6.910156 8.160156 6.753906 8.003906 L 5.429688 6.679688 Z M 6.886719 9.617188 L 8.644531 9.617188 L 8.644531 14.910156 L 6.886719 14.910156 Z M 3.414062 12.382812 L 5.171875 12.382812 L 5.171875 14.910156 L 3.414062 14.910156 Z M 10.355469 6.851562 L 12.113281 6.851562 L 12.113281 14.910156 L 10.355469 14.910156 Z M 10.355469 6.851562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSignal2);
export default __webpack_public_path__ + "static/media/no_signal2.66dc472aee439e0577c8fcc65654f30b.svg";
export { ForwardRef as ReactComponent };